<div class="voltage-report-table voltage-daily-events">
  <div class="voltage-report-table-heading">
    <div>
      <h2>رویدادهای مهم روز</h2>
      <p>تغییرات ثبت‌شدهٔ وضعیت موتور و ولتاژ</p>
    </div>
  </div>
  <div class="table-scroll" tabindex="0" role="region" aria-label="جدول رویدادهای مهم روز">
    <table>
      <thead><tr>
        <th scope="col">زمان</th>
        <th scope="col">رویداد</th>
        <th scope="col">سرعت</th>
        <th scope="col">ولتاژ</th>
        <th scope="col">توضیح</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let row of visibleRows">
          <td class="num">{{ row.time }}</td>
          <td>{{ row.title }}</td>
          <td class="num"><ng-container *ngIf="row.speed !== null; else unavailable">{{ row.speed | number:'1.0-1':'en-US' }} km/h</ng-container></td>
          <td class="num"><ng-container *ngIf="row.voltage !== null; else unavailable">{{ row.voltage | number:'1.2-2':'en-US' }} V</ng-container></td>
          <td class="voltage-event-description">{{ row.description }}</td>
        </tr>
        <tr *ngIf="!rows.length"><td colspan="5" class="voltage-report-table-empty" role="status">رویدادی برای این روز گزارش نشده است.</td></tr>
      </tbody>
    </table>
  </div>
  <app-table-pagination *ngIf="rows.length > 10" [page]="page" [pageSize]="pageSize" [totalItems]="rows.length" [pageSizeOptions]="[10, 20, 50]" (pageChange)="setPage($event)" (pageSizeChange)="setPageSize($event)"></app-table-pagination>
</div>
<ng-template #unavailable>—</ng-template>
